import maxBy from 'lodash/maxBy';
import {getSafeTranslation} from 'helpers/localization.helper.ts';

function iterateMenuEntries(mainCategories, callback) {
	mainCategories.forEach(mainCategory => {
		mainCategory.categories.forEach(category => {
			category.entries.forEach(entry => {
				callback(entry, category, mainCategory);
			});
		});
	});
}

function findMenuEntry(mainCategories, menuEntryId) {
	if (!mainCategories || !menuEntryId) {
		return null;
	}

	let result = null;

	iterateMenuEntries(mainCategories, (entry, category, mainCategory) => {
		if (entry.id === menuEntryId) {
			result = entry;

			result.categoryId = category.id;
			result.mainCategoryId = mainCategory.id;
		}
	});

	return result;
}

function getMenuWithoutUndefinedModifiers(menu) {
	if (!menu.modifierGroups) return menu;

	return {
		...menu,
		modifierGroups: menu.modifierGroups.map(modifierGroup => {
			if (!modifierGroup.modifiers) return modifierGroup;

			return {
				...modifierGroup,
				modifiers: modifierGroup.modifiers.map(modifier => {
					return {
						...modifier,
						price: modifier.price || 0,
					};
				}),
			};
		}),
	};
}

function getFullImagePath(fileName, pathId, paths) {
	if (!fileName || !paths) {
		return null;
	}

	let filePath = '';
	let fullPath = '';

	if (pathId !== '') {
		filePath = paths[pathId];
	}

	if (filePath) {
		fullPath = filePath + fileName;
	}

	//fix protocol issue for images
	fullPath = fullPath.replace('http:', 'https:');

	return fullPath;
}

function getMenuWithMappedEntries(menu, mapCallback) {
	return {
		...menu,
		menu: {
			...menu.menu,
			menu: menu.menu.menu.map(mainCategory => {
				return {
					...mainCategory,
					categories: mainCategory.categories.map(category => {
						return {
							...category,
							entries: category.entries.map(mapCallback),
						};
					}),
				};
			}),
		},
	};
}

function getMenuWithInitializedEntries(menu) {
	return getMenuWithMappedEntries(menu, entry => {
		return {
			...entry,
			fullImagePath: getFullImagePath(entry.img, entry.imgPathId, menu.menu.imgPaths),
			fullThumbnailPath: getFullImagePath(entry.thumbnail, entry.thumbnailPathId, menu.menu.thumbnailPaths),
			fullIconPath: getFullImagePath(entry.icon, entry.iconPathId, menu.menu.iconPaths),
		};
	});
}

function getInitializedMenuUpdate(rawMenus) {
	return rawMenus.map(menu => {
		return getMenuWithInitializedEntries(getMenuWithoutUndefinedModifiers(menu));
	});
}

export const hasAlcoholEntry = (menuCategories, cartItems) => {
	if (!menuCategories || !cartItems) {
		return false;
	}

	const menuEntryIdsWithAlcohol = menuCategories
		.map((category) => category.categories)
		.reduce((categoryOne, categoryTwo) => [...categoryOne, ...categoryTwo])
		.map((subcategory) => subcategory.entries)
		.reduce((entriesOne, entriesTwo) => [...entriesOne, ...entriesTwo])
		.filter((entry) => entry.isAlcohol)
		.map((entry) => entry.id);

	if (menuEntryIdsWithAlcohol.length === 0) {
		return false;
	}

	const cartMenuEntryIds = cartItems.map((cartItem) => cartItem.menuEntryId);

	return cartMenuEntryIds.some((cartMenuEntryId) => menuEntryIdsWithAlcohol.includes(cartMenuEntryId));
}

export const getMenuEntry = (mainCategories, menuEntryId) => {
	if (!mainCategories || !menuEntryId) {
		return null;
	}

	return findMenuEntry(mainCategories, menuEntryId);
};

export const getCategoryFromMainCategories = (mainCategories, categoryId) => {
	if (!mainCategories || !categoryId) {
		return null;
	}

	const mainCategory = mainCategories.find(mainCategory =>
		mainCategory.categories.find(category => category.id === categoryId)
	);

	return mainCategory.categories.find(category => category.id === categoryId);
};

export const getUpdatedMenuCache = (currentCache, update, customer) => {
	update = getInitializedMenuUpdate(update);

	const restaurantIds = [];

	update.forEach(menu => {
		if (!restaurantIds.includes(menu.restaurantId)) {
			restaurantIds.push(menu.restaurantId);
		}
	});

	const updatedMenus = [...currentCache.filter(menu => !restaurantIds.includes(menu.restaurantId))];

	restaurantIds.forEach(restaurantId => {
		var existingMenusForRestaurant = currentCache.filter(menu => {
			return (
				menu.restaurantId === restaurantId &&
				menu.locale === ((customer && customer.locale) || null) &&
				menu.customerGroup === ((customer && customer.customerGroupIds) || '0')
			);
		});

		var updatedMenusForRestaurant = update.filter(menu => {
			return menu.restaurantId === restaurantId;
			return (
				menu.restaurantId === restaurantId &&
				menu.locale === ((customer && customer.locale) || null) &&
				menu.customerGroup === ((customer && customer.customerGroupIds) || '0')
			);
		});

		var menuVersionRegex = /^[0-9]+\.([0-9]+)$/;

		var menuWithMaxVersion = maxBy(
			updatedMenusForRestaurant.length > 0 ? updatedMenusForRestaurant : existingMenusForRestaurant,
			function (restaurantMenu) {
				var menuVersionSearchResults = menuVersionRegex.exec(restaurantMenu.menu.menuVersion);
				return menuVersionSearchResults && menuVersionSearchResults.length >= 2
					? Number(menuVersionSearchResults[1])
					: '';
			}
		);

		if (menuWithMaxVersion) {
			updatedMenus.push({
				...menuWithMaxVersion,
				isCached: true,
			});
		}
	});

	return updatedMenus;
};
